// Vendor Ready Utility
// Ensures code only executes after vendor bundle (jQuery, global.js, etc.) has fully loaded
// The vendor.ts entrypoint dispatches a 'vendorReady' event when all plugins are loaded

/**
 * Waits for the vendor bundle to be ready before executing a callback
 * @param callback - Function to execute once vendor is ready
 */
export function onVendorReady(callback: () => void): void {
  if ((window as any).__vendorReady) {
    // Vendor already loaded
    callback()
  } else {
    // Wait for vendorReady event
    window.addEventListener('vendorReady', callback, { once: true })
  }
}

/**
 * Returns a promise that resolves when vendor is ready
 * Useful for async/await patterns
 */
export function waitForVendor(): Promise<void> {
  return new Promise((resolve) => {
    onVendorReady(() => resolve())
  })
}
